import React, { useState } from 'react';
import { Snackbar, IconButton } from '@material-ui/core';
import { Alert, AlertProps } from '@material-ui/lab';
import { Close } from '@material-ui/icons';

const useSnackbar = () => {
  const [isSnackbarVisible, setIsSnackbarVisible] = useState<boolean>(false);
  const [snackbarType, setSnackbarType] = useState<AlertProps['severity']>(undefined);
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');

  const showMessage = (message: string, severity?: AlertProps['severity']) => {
    setSnackbarMessage(message);
    setSnackbarType(severity);
    if (isSnackbarVisible)
      setIsSnackbarVisible(false);
    setTimeout(() => setIsSnackbarVisible(true));
  };

  return {
    renderSnackbar() {
      return (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={isSnackbarVisible}
          autoHideDuration={3000}
          message={snackbarMessage}
          onClose={() => setIsSnackbarVisible(false)}
          action={
            <IconButton size="small" aria-label="close" color="inherit" onClick={() => setIsSnackbarVisible(false)}>
              <Close fontSize="small" />
            </IconButton>
          }>
          {snackbarType ? (<Alert severity={snackbarType}>{snackbarMessage}</Alert>) : undefined}
        </Snackbar>
      );
    },
    showMessage
  };
};

export default useSnackbar;